/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Metadata of an VMUA RSA key pair managed by the service plane.
 */
export interface VmuaKeyInfo { 
    /**
     * Unique key identifier, e.g. vmua-key-20260401-a3f9bc12.
     */
    keyId?: string;
    /**
     * Entity this key belongs to. \"GLOBAL\" for simple (basic) mode keys.
     */
    entityId?: string;
    /**
     * Software version of the entity at the time the key was generated.
     */
    entityVersion?: string;
    /**
     * Algorithm descriptor, e.g. RSA-OAEP-SHA-256/AES-256-GCM.
     */
    algorithm?: string;
    /**
     * Lifecycle status of the key.
     */
    status?: VmuaKeyInfo.StatusEnum;
    /**
     * AWS Secrets Manager path where the private key credential is stored.
     */
    secretManagerPath?: string;
    /**
     * PEM-encoded RSA public key (X.509 format). Only populated on the generate response. Share this with SnapService so they can encrypt Content Encryption Keys with it.
     */
    publicKeyPem?: string;
    /**
     * Timestamp when the key pair was generated.
     */
    createdAt?: Date;
    /**
     * Timestamp when the key fully expires. Null while the key is ACTIVE. Set when the operator initiates expiry; during the grace period the key is in GRACE status.
     */
    expiresAt?: Date;
}
export namespace VmuaKeyInfo {
    export type StatusEnum = 'ACTIVE' | 'GRACE' | 'EXPIRED';
    export const StatusEnum = {
        ACTIVE: 'ACTIVE' as StatusEnum,
        GRACE: 'GRACE' as StatusEnum,
        EXPIRED: 'EXPIRED' as StatusEnum
    };
}


